import {useState,useEffect} from 'react'
import {useNavigate} from "react-router-dom"
import {useDispatch} from "react-redux"
import { loginUser } from '../store/actions'
import Swal from 'sweetalert2'
function LoginPage(){
    const dispatch= useDispatch()
const navigate= useNavigate()
    const [loginInput, setLogin]= useState({
        email: "",
        password: "",
    })

   let inputLogin= (e)=> {
        const {name,value}= e.target
        const input= {
            ...loginInput,
            [name]: value
            
        }
      
        setLogin(input)
    }

const loginHandler= (e)=>{
    e.preventDefault();
       dispatch(loginUser(loginInput))
       .then((response)=>{
        if(response.access_token){
            localStorage.setItem("access_token", response.access_token)
            localStorage.setItem("name", response.name)
            navigate('/')
            Swal.fire({
                icon: 'success',
                title: `Login success`
            })
        }else{
            Swal.fire({
                icon: 'error',
                title: response.message
            })
            navigate('/login')
        }
    })
    .catch((error)=>{
        console.log(error);
    })
    }
    
    return(
        <div>
            <form onSubmit={loginHandler}>
        <div className="justify-center items-center flex flex-col" style={{height:"410px"}}>
            <img src="https://d3g5ywftkpzr0e.cloudfront.net/wp-content/uploads/2020/01/15094433/hacktiv8-1.png" alt="" style={{width:"200px"}} />
        <div className="border-2 text-center rounded-lg" style={{width: "400px", height: "300px"}}>
            <p className="font-bold" style={{fontSize: "15pt"}}>Sign In To Your Account</p>
            <div className="pt-5">
            <label>Email Address</label><br/>
            <input value={loginInput.email} name="email" onChange={inputLogin}  type="text" style={{width: "300px", height:"35px"}} placeholder="Email Address" className="border-2 rounded-md pl-2"/>
            </div>
            <div className="pt-5">
             <label>Password</label><br/>
            <input value={loginInput.password} name="password" onChange={inputLogin} type="password" style={{width: "300px", height:"35px"}} placeholder="Password"  className="border-2 rounded-md pl-2"/>
            </div>
            <div className="pt-5 pb-8">
            <button className="bg-purple-400 h-8 rounded-lg hover:bg-purple-300"  style={{width: "300px", height:"35px"}}>Sign In</button>
            </div>
        </div>
        </div>
        </form>
        </div>
    )
}

export default LoginPage